<div fxLayout="row" fxLayoutAlign="start center">
  <h1>
    {{ "MERCHANT.SITES.CREATE.TITLE" | translate }}
  </h1>
</div>

<mat-card>
  <app-merchant-site-edit
    [site]="null"
    [basicData]="basicData$ | async"
    [error]="error$ | async"
    [isLoading]="false"
    (submitted)="onSubmit($event)"
  >
  </app-merchant-site-edit>
</mat-card>
